export function createDefaultSubTenant(overrides = {}) {
  return {
    subTenantCode: "string",
    subTenantName: "string",
    enabled: true,
    tenantDTO: {
      id: 0
    },
    ...overrides,
  };
}
